<template>
    <div :class="wrapperClass" v-if="noLabel && !noWrapper">
        <v-select
            :class="wrapperClass"
            v-model="selected"
            :options="items"
            label="name"
            @input="setSelected"
            v-if="searchable"
            :placeholder="placeholder"
        ></v-select>
        <select
            v-else
            v-model="selected"
            :class="selectClass"
            @input="setValue($event)"
            :style="font"
        >
            <option value="" v-if="unselectedLabel">{{ unselectedLabel }}</option>
            <option
                v-for="(item, index) in items"
                v-if="allowed(item)"
                :value="getValue(item)"
                :key="index + 0"
            >
                {{ getLabel(item) }}
            </option>
        </select>
    </div>
    <div :class="wrapperClass" v-else-if="!noLabel && !noWrapper">
        <v-select
            v-model="selected"
            :options="items"
            :label="labelAttribute"
            @input="setSelected"
            v-if="searchable"
            :placeholder="placeholder"
        ></v-select>
        <template v-else>
            <span class="trip-title px-2">{{ label }}</span>
            <select
                v-model="selected"
                :class="selectClass"
                class="italic"
                @input="setValue($event)"
                :style="font"
            >
                <option
                    v-if="allowedValues.length && allowedValues[item.id]"
                    v-for="(item, index) in items"
                    :value="getValue(item)"
                    :key="index + 0"
                >
                    {{ getValue(item) }}
                </option>
                <option
                    v-if="!allowedValues.length"
                    v-for="(item, index) in items"
                    :value="getValue(item)"
                    :key="index + 0"
                >
                    {{ getValue(item) }}
                </option>
            </select>
        </template>
    </div>
    <span v-else>
        <v-select
            v-model="selected"
            :options="items"
            label="name"
            @input="setSelected"
            v-if="searchable"
            :placeholder="placeholder"
        ></v-select>
        <select
            v-else
            v-model="selected"
            :class="selectClass"
            @input="setValue($event)"
            :style="font"
        >
            <option
                v-for="(item, index) in items"
                v-if="allowedValues.length && allowedValues[item.id]"
                :value="getValue(item)"
                :key="index + 0"
            >
                {{ getLabel(item) }}
            </option>
            <option
                v-if="!allowedValues.length"
                v-for="(item, index) in items"
                :value="getValue(item)"
                :key="index + 0"
            >
                {{ getLabel(item) }}
            </option>
        </select>
    </span>
</template>

<script>
export default {
  data () {
    return {
      unselectedLabel: this.noneLabel,
      selected: '',
      font: null
    }
  },
  props: {
    items: {
      default: () => [{id: 0, name: ''}],
      type: Array,
      required: true
    },
    valueAttribute: {
      default: 'id',
      type: String,
      required: false
    },
    labelAttribute: {
      default: 'name',
      type: String,
      required: false
    },
    wrapperClass: {
      default: 'col d-flex align-items-center',
      type: String,
      required: false
    },
    selectClass: {
      default: 'right-chevron',
      type: String,
      required: false
    },
    noLabel: {
      default: false,
      type: Boolean,
      required: false
    },
    noneLabel: {
      default: '',
      type: String,
      required: false
    },
    noWrapper: {
      default: false,
      type: Boolean,
      required: false
    },
    selectedValue: {
      default: null,
      type: String | Number,
      required: false
    },
    searchable: {
      default: false,
      type: Boolean,
      required: false
    },
    isHeader: {
      default: false,
      type: Boolean,
      required: false
    },
    allowedValues: {
      default: () => ([]),
      type: Array,
      required: false
    },
    simpleValue: {
      default: false,
      type: Boolean,
      required: false
    },
    translateLabels: {
      default: false,
      type: Boolean,
      required: false
    },
    placeholder: {
      default: '',
      type: String,
      required: false
    }
  },
  computed: {
    label () {
      let needle = this.selected
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i][this.valueAttribute] === needle) {
          return this.items[i][this.labelAttribute]
        }
      }
      return ''
    }
  },
  methods: {
    allowed (item) {
      if (!this.allowedValues.length) {
        return true
      }
      if (this.allowedValues.indexOf(item.id) !== -1) {
        return true
      }
      return false
    },
    // For searchable drop-down only
    setSelected (value) {
      this.$emit('update:selectedValue', value)
    },
    // For normal drop-down
    setValue (event) {
      if (!this.simpleValue) {
        this.$emit('update:selectedValue', this.items[event.target.selectedIndex])
      } else {
        this.$emit('update:selectedValue', event.target.value)
      }
    },
    getValue (item) {
      return (typeof item[this.valueAttribute] !== 'undefined') ? item[this.valueAttribute] : item.id
    },
    getLabel (item) {
      if (typeof item[this.labelAttribute] !== 'undefined') {
        return this.translateLabels ? this.$t(item[this.labelAttribute]) : item[this.labelAttribute]
      }

      return item.name_NL
    }
  },
  created () {
    if (this.selectedValue && !this.searchable) {
      if (typeof this.selectedValue === 'object') {
        this.selected = this.selectedValue[this.valueAttribute]
      } else {
        this.selected = this.selectedValue
      }
    } else if (this.selectedValue && this.searchable) {
      // Translated?
      if (this.selectedValue.hasOwnProperty('name_NL')) {
        this.selected = this.selectedValue.name_NL
      } else {
        this.selected = this.selectedValue
      }
    }

    if (this.items.length && !this.selectedValue) {
      if (this.searchable || this.noneLabel !== '') {
        this.selected = ''
      } else {
        this.selected = this.items[0][this.valueAttribute]
      }
      this.$emit('update:selectedValue', this.selected)
    }
  }
}
</script>

<style scoped>
    div >>> .vs--searchable {
        width: 100%;
    }
    div >>> .vs__selected-options {
        max-height: 34px;
        padding-left: 0;
        overflow: hidden;
    }
    div >>> .vs__selected {
        position: absolute;
        top: -2px;
    }
    div >>> .vs__selected,
    div >>> .vs__search {
        width: 100%;
        color: inherit;
        font-size: inherit;
        font-family: "Open Sans";
    }
    div >>> .vs__dropdown-toggle {
        border: 0;
        padding: 0;
    }
    div >>> .vs__dropdown-menu {
        z-index: 100;
        overflow-x: hidden;
    }
    div >>> .vs__clear {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/core/DropDown.vue